import PropTypes from 'prop-types';
import React, {Component} from 'react';
import connect from 'react-redux/es/connect/connect';
import {
  addFidsAsset, fetchFidsAssets,
  setPageTitle, updateFidsAsset,
} from '../../actions';
import {Page} from '../../components';
import Box from '../../components/layout/Box';
import Button from '../../components/widgets/Button';
import {getAsset} from '../../selectors';
import './styles.scss';
import request from "superagent";
import {API_ROOT} from "signoxe/constants/config";

const getAuthTokenHeader = () => `Bearer ${localStorage.getItem('token')}`;

class FidsAssetEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {...props.asset};
  }

  static propTypes = {
    fetchFidsAssets: PropTypes.func.isRequired,
    updateFidsAsset: PropTypes.func.isRequired,
    addFidsAsset: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    asset: PropTypes.object,
    params: PropTypes.object,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };

  handleCancel = () => this.props.history.push('/assets');

  handleNameChange = (e) => this.setState({name: e.currentTarget.value});

  handleFLightsPerScreenChange = (e) => this.setState({flights_per_screen: e.currentTarget.value});

  handleShowForSecondsChange = (e) => this.setState({show_for_seconds: e.currentTarget.value});

  handleDisplayChange = (e) => this.setState({departures: e.currentTarget.value});

  handleAirportChange = (e) => this.setState({airport_code: e.currentTarget.value});

  handleSave = () => {
    if (this.props.asset) {
      this.props.updateFidsAsset(this.props.asset.id, this.state);
      this.props.history.push(`/asset/${this.props.asset.id}`);
    } else if (this.isNewAsset()) {
      this.props.addFidsAsset(this.state);
      this.props.history.push('/assets');
    }
  }

  isNewAsset = () => this.props.match.params.id === undefined;

  componentDidMount() {
    this.props.fetchFidsAssets();
    request
    .get(`${API_ROOT}airport_codes/`)
    .set('Authorization', getAuthTokenHeader())
    .accept('application/json')
    .then(response => this.setState({airportCodes: response.body}));
    if (this.props.asset) {
      this.props.setPageTitle(`${this.props.asset.id ? 'Editing' : 'Adding'} Fids Asset`);
    } else {
      this.props.setPageTitle('Adding Fids Asset');
    }
  }

  componentWillReceiveProps(newProps) {
    if (this.props.asset !== newProps.asset) {
      this.setState(newProps.asset);
    }
  }

  render() {
    if (this.props.asset === undefined && this.props.match.params.id) {
      return <div>Invalid asset.</div>;
    }

    const {name, departures, flights_per_screen, show_for_seconds, airport_code} = this.state;

    return (
      <Page className="fids-asset-editing-page">
        <input type="text" placeholder="Asset name"
               value={name || ''}
               onChange={this.handleNameChange}/>
        <select id="airport-selector" name="template-selector"
                value={airport_code}
                onChange={this.handleAirportChange}>
          <option value="NULL" key="null">----</option>
          {this.state.airportCodes && (this.state.airportCodes.map(airportCode =>
            (<option key={airportCode.id}
                     value={airportCode.id}>{airportCode.airport_name}</option>),
          ))}
          )
        </select>
        <select id="departures-selector" name="template-selector"
                value={departures}
                onChange={this.handleDisplayChange}>
          <option value="NULL" key="null">----</option>
          <option key={1} value={true}>Departures</option>
          <option key={2} value={false}>Arrivals</option>
          )
        </select>
        <input type="number" placeholder="Number of flights per screen"
               value={flights_per_screen}
               onChange={this.handleFLightsPerScreenChange}/>
        <input type="number" placeholder="Show each page for (seconds)"
               value={show_for_seconds}
               onChange={this.handleShowForSecondsChange}/>
        <Box direction="row" justifyContent="flex-end" className="actions button-group">
          <Button primary onClick={this.saveEnabled() ? this.handleSave : null}>Save</Button>
          <Button secondary onClick={this.handleCancel}>Cancel</Button>
        </Box>
      </Page>
    );
  }

  saveEnabled() {
    return this.state && this.state.name;
  }
}

export default connect(
  (state, {match}) => ({
    asset: getAsset(state, parseInt(match.params.id, 10)),
  }), {
    fetchFidsAssets,
    updateFidsAsset,
    addFidsAsset,
    setPageTitle,
  },
)(FidsAssetEditPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/FidsAssetEditPage/index.js